import React from 'react';
import { TCMLanding } from './pages/TCMLanding';
function App() {
  return <TCMLanding data-id="element-0" />;
}
export { App };